import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Restaurant = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="restaurant"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.3368 15.4811C9.25182 15.4882 9.16705 15.4919 9.08207 15.4919C8.84959 15.4919 8.62349 15.4582 8.40208 15.4069L3.27893 20.5302C3.02747 20.7813 3.02747 21.1892 3.27893 21.4403L4.60485 22.7666C4.85631 23.0177 5.26373 23.0177 5.5145 22.7666L11.6718 16.6104L10.5307 15.3792L9.3368 15.4811Z" />
      <path d="M22.8194 7.27334C22.579 7.03302 22.1898 7.03302 21.9494 7.27334L18.6294 10.5933C18.3153 10.9071 17.8064 10.9071 17.4923 10.5933C17.1795 10.2797 17.1795 9.77127 17.4923 9.45778L20.7959 6.15486C21.0455 5.90503 21.0455 5.50003 20.7959 5.24963C20.5451 5.00012 20.1403 5.00012 19.8907 5.24963L16.5884 8.55222C16.2743 8.86636 15.766 8.86636 15.4519 8.55222C15.1384 8.23877 15.1384 7.72996 15.4519 7.41675L18.7712 4.09713C19.0123 3.85645 19.0123 3.4666 18.7712 3.22559C18.5308 2.98486 18.1409 2.98486 17.8998 3.22559L14.1651 6.9605C13.2672 7.859 12.9836 9.1202 13.2743 10.2678L15.7779 12.7716C16.9254 13.0612 18.1872 12.7774 19.0841 11.8797L22.8194 8.14497C23.0605 7.90428 23.0605 7.51402 22.8194 7.27334Z" />
      <path d="M4.67803 3.56314C4.55005 3.43512 4.37699 3.36493 4.19927 3.36493C4.16146 3.36493 4.12344 3.36816 4.08632 3.37436C3.8701 3.41095 3.68459 3.54975 3.58928 3.74731C2.4953 6.00848 2.95249 8.71414 4.72833 10.4901L7.90536 13.6667C8.21881 13.9805 8.64264 14.1542 9.08219 14.1542C9.12919 14.1542 9.17631 14.1523 9.22331 14.1484L11.0679 13.991L19.1112 22.668C19.2361 22.8029 19.4111 22.8812 19.5953 22.8848C19.5991 22.8848 19.6031 22.8848 19.6071 22.8848C19.7873 22.8848 19.9598 22.8137 20.0878 22.6866L21.4653 21.3088C21.5926 21.1818 21.6637 21.0094 21.6637 20.8298C21.6637 20.6502 21.5926 20.4777 21.4658 20.3507L4.67803 3.56314Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Restaurant.defaultProps = {
  className: null,
};

Restaurant.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Restaurant;
